import React, { PropsWithChildren, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import { FormControl, TextField } from '@material-ui/core';
import { useAppState } from '../../state';

interface InviteDialogProps {
  open: boolean;
  onClose(): void;
}

function InviteDialog({ open, onClose }: PropsWithChildren<InviteDialogProps>) {
  const [message, setMessage] = useState('');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => setMessage(e.target.value);
  const { setError } = useAppState();
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (message) {
      fetch(
        process.env.REACT_APP_TOKEN_ENDPOINT +
          '/api/room-email?m=' +
          new URLSearchParams(window.location.search).get('m') +
          '&em=' +
          message
      )
        .then(response => response.json())
        .then(jsonData => {
          if (jsonData.length > 0) {
            jsonData.map((j: { [x: string]: any }) => {
              const key = Object.keys(j)[0];
              const value = j[key];
              // @ts-ignore
              setError({
                message: 'Info|' + value,
              });
              return null;
            });
          }
        })
        .catch(error => {
          const hiba = 'Meghívás hiba: ' + error.toString();
          // @ts-ignore
          setError({
            message: hiba,
          });
        });

      //Reset the text field
      setMessage('');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth="xs">
      <DialogTitle>Meghivás</DialogTitle>
      <Divider />
      <DialogContent>
        <form autoComplete="off" style={{ display: 'flex', alignItems: 'center' }} onSubmit={handleSubmit}>
          <FormControl>
            <label htmlFor="chat-snack-input" style={{ color: 'black' }}>
              E-Mail:
            </label>
            <TextField value={message} autoFocus={true} onChange={handleChange} id="chat-snack-input" size="small" />
          </FormControl>
          <Button type="submit" color="primary" variant="contained" style={{ marginLeft: '0.8em' }}>
            Meghívás
          </Button>
        </form>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained" autoFocus>
          Bezár
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default InviteDialog;
